(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('.disclosure__list-wrapper'),
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('a').forEach((item) => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      if (form) form.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute(
        'aria-expanded',
        (this.elements.button.getAttribute('aria-expanded') === 'false').toString()
      );
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }

  customElements.define('localization-form', LocalizationForm);

  function attachCheckboxListener() {
    var checkbox = document.getElementById('signup-checkbox-footer');
    var submitButton = document.getElementById('FooterSubscribe');

    if (checkbox && submitButton) {
      checkbox.removeEventListener('change', toggleSubmitButton);
      checkbox.addEventListener('change', toggleSubmitButton);

      submitButton.disabled = !checkbox.checked;
    }
  }

  function toggleSubmitButton() {
    var submitButton = document.getElementById('FooterSubscribe');
    if (submitButton) {
      submitButton.disabled = !this.checked;
    }
  }

  document.addEventListener('DOMContentLoaded', attachCheckboxListener);
  document.addEventListener('shopify:section:select', attachCheckboxListener);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  
class StickyHeader extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.header = document.querySelector('.section-header');
    this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
    this.headerBounds = {};

    this.setHeaderHeight();

    const marginDesktopValue = this.getAttribute('data-margin-desktop');
    // Fetch data-margin-desktop and calculate percentage
    this.marginDesktopPercentage = parseFloat(marginDesktopValue) || 2; 
    this.marginDesktopThreshold = this.marginDesktopPercentage*2 / 100; 

    const marginMobileValue = this.getAttribute('data-margin-mobile');
    this.marginMobilePercentage = parseFloat(marginMobileValue) || 2; 
    this.marginMobileThreshold = this.marginMobilePercentage / 300; 

    window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

    if (this.headerIsAlwaysSticky) {
      this.header.classList.add('shopify-section-header-sticky');
    };

    this.currentScrollTop = 0;
    this.preventReveal = false;
    this.predictiveSearch = this.querySelector('predictive-search');

    this.onScrollHandler = this.onScroll.bind(this);
    this.hideHeaderOnScrollUp = () => this.preventReveal = true;

    this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
    window.addEventListener('scroll', this.onScrollHandler, false);

    this.createObserver();
  }

  setHeaderHeight() {
    document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
  }

  disconnectedCallback() {
    this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
    window.removeEventListener('scroll', this.onScrollHandler);
  }

  createObserver() {
    let observer = new IntersectionObserver((entries, observer) => {
      this.headerBounds = entries[0].intersectionRect;
      observer.disconnect();
    });

    observer.observe(this.header);
  }

  onScroll() {
    const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
    const scrollThreshold = 250; 
    const viewportWidth = window.innerWidth;
    let resetOffset;

    if (viewportWidth < 990) {
      resetOffset = window.innerHeight * this.marginMobileThreshold;
    } else {
      // Using desktop threshold
      resetOffset = window.innerHeight * this.marginDesktopThreshold;
    }
    
    if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

    if (scrollTop > this.currentScrollTop && scrollTop > (this.headerBounds.bottom + scrollThreshold)) {
      this.header.classList.add('scrolled-past-header');
      if (this.preventHide) return;
      requestAnimationFrame(this.hide.bind(this));
    } else if (scrollTop < this.currentScrollTop && scrollTop > (this.headerBounds.bottom + scrollThreshold)) {
      this.header.classList.add('scrolled-past-header');
      if (!this.preventReveal) {
        requestAnimationFrame(this.reveal.bind(this));
      } else {
        window.clearTimeout(this.isScrolling);

        this.isScrolling = setTimeout(() => {
          this.preventReveal = false;
        }, 66);

        requestAnimationFrame(this.hide.bind(this));
      }
    } else if (scrollTop <= this.headerBounds.top + resetOffset) {
      this.header.classList.remove('scrolled-past-header');
      requestAnimationFrame(this.reset.bind(this));
    }

    this.currentScrollTop = scrollTop;
  }

  hide() {
    if (this.headerIsAlwaysSticky) return;
    this.header.classList.add('shopify-section-header-hidden');
    this.header.classList.remove('shopify-section-header-sticky');
    this.closeMenuDisclosure();
    this.closeSearchModal();
  }

  reveal() {
    if (this.headerIsAlwaysSticky) return;
    this.header.classList.add('shopify-section-header-sticky');
    this.header.classList.remove('shopify-section-header-hidden');
  }

  reset() {
    if (this.headerIsAlwaysSticky) return;
    this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky');
  }

  closeMenuDisclosure() {
    this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
    this.disclosures.forEach(disclosure => disclosure.close());
  }

  closeSearchModal() {
    this.searchModal = this.searchModal || this.header.querySelector('details-modal');
    this.searchModal.close(false);
  }
}

customElements.define('sticky-header', StickyHeader);

  function initIntersectionObserver() {
  const headers = document.querySelectorAll('.enable-fixed-header-part--true.enable-header-full-width--false');

  if (!headers.length) return; // Ensure there are elements to observe

  const observer = new IntersectionObserver((entries, observer) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        entry.target.classList.add('in-view');
        observer.unobserve(entry.target); 
      }
    });
  }, { threshold: 1 });

  headers.forEach(header => {
    observer.observe(header);
  });
}

initIntersectionObserver();

document.addEventListener('shopify:section:load', () => {
  initIntersectionObserver();
});


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
    (function () {
      // Only render when metafield is true (you already wrapped the HTML/CSS with the Liquid IF)
      const popup = document.getElementById('hygiPopup');
      if (!popup) return;

      const dialog = popup.querySelector('.hygi-popup__dialog');
      const overlay = popup.querySelector('.hygi-popup__overlay');
      const btnClose = popup.querySelector('[data-hygi-close]');
      const btnConfirm = document.getElementById('hygiConfirm');
      const chkAck = document.getElementById('hygiAcknowledge');

      // Find the product form (to gate add-to-cart)
      const productForm = document.querySelector('form[action*="/cart/add"]');

      let acknowledged = false; // page-scoped (resets each visit)
      let pendingSubmit = null;

      function focusables() {
        return dialog.querySelectorAll('button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])');
      }

      function openPopup() {
        if (popup.hasAttribute('hidden')) popup.removeAttribute('hidden');
        requestAnimationFrame(() => {
          popup.classList.add('hygi--open');
          document.documentElement.classList.add('hygi-lock');
          const f = focusables()[0];
          if (f) f.focus();
        });
      }

      function closePopup() {
        popup.classList.remove('hygi--open');
        document.documentElement.classList.remove('hygi-lock');
        setTimeout(() => popup.setAttribute('hidden', ''), 150);
      }

      // Enable confirm only when acknowledged
      chkAck?.addEventListener('change', () => {
        btnConfirm.disabled = !chkAck.checked;
      });

      // Confirm: mark acknowledged for this page and continue
      btnConfirm?.addEventListener('click', () => {
        acknowledged = true;
        closePopup();
        if (pendingSubmit) {
          const submitter = pendingSubmit;
          pendingSubmit = null;
          // Re-trigger the original submit/click
          if (submitter.tagName === 'BUTTON' || submitter.type === 'submit') {
            submitter.click();
          } else if (productForm) {
            productForm.submit();
          }
        }
      });

      // Close handlers
      overlay?.addEventListener('click', closePopup);
      btnClose?.addEventListener('click', closePopup);

      document.addEventListener('keydown', (e) => {
        if (e.key === 'Escape' && popup.classList.contains('hygi--open')) {
          e.preventDefault();
          closePopup();
        }
        // Focus trap
        if (e.key === 'Tab' && popup.classList.contains('hygi--open')) {
          const f = Array.from(focusables());
          if (!f.length) return;
          const first = f[0],
            last = f[f.length - 1];
          if (e.shiftKey && document.activeElement === first) {
            e.preventDefault();
            last.focus();
          } else if (!e.shiftKey && document.activeElement === last) {
            e.preventDefault();
            first.focus();
          }
        }
      });

      // Always show on page load
      openPopup();

      // Gate Add to Cart until acknowledged (every visit)
      if (productForm) {
        productForm.addEventListener(
          'submit',
          (e) => {
            if (!acknowledged) {
              e.preventDefault();
              pendingSubmit = e.submitter || productForm.querySelector('[type="submit"]');
              openPopup();
            }
          },
          true
        );
      }
    })();
  
  } catch(e) { console.error(e); }
})();
})();
